import RedactionItem from './RedactionItemContainer';

export default RedactionItem;